import React from 'react' 

const Header = () => {
  const logo="https://i0.wp.com/optifinish.in/wp-content/uploads/2021/01/cropped-logo-optifinish-1-ox6t4o7hcpuzkseypt1ar1lhx4ml1d09skbori7dx8.png?fit=50%2C50&ssl=1"
  return (
    <div className='head'>
      <div className='bar'>
        <img src={logo} alt='logo'/>
        <h4>Value Added Coating Solution Pvt Ltd</h4>
      </div>
    </div>
  )
}

export default Header
